"use client";
import { Separator } from "@/components/ui/separator";
import Trophy from "./trophy";
import { useId } from "react"; // 1. Import useId

type CardProps = {
  title: string;
  description: string;
};

export default function MobileCard(props: CardProps) {
  const { title, description } = props;
  const cardGradientId = useId(); // 2. Create ID for the gradient

  return (
    <div className="relative h-full max-h-[320px] rounded-[20px] bg-[#3A285C]/20 px-10 py-10 backdrop-blur-md">
      <svg
        className="pointer-events-none absolute inset-0 z-0 h-full w-full"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <defs>
          <linearGradient
            id={cardGradientId}
            x1="840"
            y1="0"
            x2="840"
            y2="436"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F0DFC1" />
            <stop offset="0.791452" stopColor="#C89452" />
            <stop offset="1" stopColor="#B07F44" />
          </linearGradient>
        </defs>
        <rect
          x="0.5"
          y="0.5"
          width="calc(100% - 1px)"
          height="calc(100% - 1px)"
          rx="20"
          ry="20"
          fill="none"
          stroke={`url(#${cardGradientId})`}
          strokeWidth="1"
        />
      </svg>

      <div className="relative">
        <div className="flex flex-col items-start gap-4">
          <div className="flex items-center gap-4">
            <Trophy />
            <p className="w-[130px] text-xl ltr:font-playfair">{title}</p>
          </div>
          <Separator className="bg-[#FFF4E3]" />
          <div className="text-secondary/60">{description}</div>
        </div>
      </div>
    </div>
  );
}
